import { XdrSearchResultsPanelWebComponent } from './component/XdrSearchResultsPanelWebComponent';
import { WEB_COMPONENT_XDR_SEARCH_RESULTS_PANEL } from '../../webcomponents.constants';

export { XdrSearchResultsPanelWebComponent };

window.customElements.define(WEB_COMPONENT_XDR_SEARCH_RESULTS_PANEL, XdrSearchResultsPanelWebComponent);
